import { FC } from 'react';
import { getCrownIcon, getTrophyIcon } from 'static/assets/icons';

type Props = {
  img: string;
  imgSize: number;
  ranking: number;
  name: string;
  points: number;
};

export const PodiumAvatar: FC<Props> = ({ img, imgSize, ranking, name, points }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col items-center">
        {ranking === 1 ? getCrownIcon('40px', '35px', 'z-10 mb-[-12px]') : ''}
        <img className={`h-${imgSize} w-${imgSize} rounded-full border-solid border-2 border-tertiary`} src={img} alt={`${name} som blev nr. ${ranking}`} />
        <p className="w-7 h-7 pt-1 mt-[-12px] bg-tertiary rounded-full font-bold text-center">{ranking}</p>
      </div>

      <p className={`w-${imgSize} truncate text-center font-semibold`}>{name}</p>
      <p className="flex flex-row gap-0.5 text-sm">
        {getTrophyIcon('16px')}
        {points} pts
      </p>
    </div>
  );
};
